import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { ConfirmSignInComponent } from './confirm-sign-in.component';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputGroupModule } from 'primeng/inputgroup';
import { MessageModule } from 'primeng/message';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [ConfirmSignInComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    FloatLabelModule,
    FormsModule,
    InputGroupAddonModule,
    InputGroupModule,
    MessageModule,
    ReactiveFormsModule,
  ],
  exports: [ConfirmSignInComponent],
})
export class ConfirmSignInModule {}
